import axios from 'axios';
import { systemOf } from '../constants/systems';

const pruneEmptyZones = (zones) =>
  (zones || [])
    .map((zone) => {
      if (zone?.specific_location) {
        const specificLocation = zone.specific_location.filter(
          (subLocation) => (subLocation?.devices || []).length > 0,
        );

        return specificLocation.length > 0
          ? { ...zone, specific_location: specificLocation }
          : null;
      }

      return (zone?.devices || []).length > 0 ? zone : null;
    })
    .filter(Boolean);

const prune = (data, params) =>
  params?.structured ? pruneEmptyZones(data) : data;

// GET /get-zones/{switches|blowers}. TES shares the blower list, filtered by
// `type: 'TES'`.
export const getZones = async (system, params) => {
  const { resource, zonesQuery } = systemOf(system);
  const response = await axios.get(`/get-zones/${resource}`, {
    params: zonesQuery ? { ...zonesQuery, ...params } : params,
  });
  return prune(response.data, params);
};

export const uploadSiteMapService = async (
  zoneId,
  switchType,
  siteMapArray,
  specificZoneId,
) => {
  const response = await axios.patch(`/zones/${zoneId}`, {
    ...(switchType === 'ess' && {
      site_maps_ESS: siteMapArray,
    }),
    ...(switchType === 'tes' && {
      site_maps_TES: siteMapArray,
    }),
    ...(switchType === 'tgs' && {
      site_maps_TGS: siteMapArray,
    }),
  });
  return response.data;
};
